<template>
  <el-timeline v-if="list.length">
    <el-timeline-item :timestamp="item.insertTime" placement="top" v-for="item in list" :key="item.id">
      <el-card>
        <div class="history">
          <h4>{{ item.trackName }}</h4>
          <p>歌曲id：{{ item.tmeTrackId }}</p>
          <p>操作人：{{ item.operUser }}</p>
          <p>原因：{{ item.reason }}</p>
          <p>转交人：{{ item.transferUser }}</p>
        </div>
      </el-card>
    </el-timeline-item>
  </el-timeline>
  <div v-else>
    暂无审核记录
  </div>
</template>

<script>
export default {
  name: 'History',
  props: {
    list: {
      type: Array,
      required: true
    }
  }
}

</script>

<style>
.history {
  line-height: 30px;
}
</style>
